import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getNotificationsKey } from '../../utils/keys';
export const DefaultNotificationLimit = 10;
export const useNotifications = (options) => {
    const { variables = { limit: DefaultNotificationLimit }, fields = {
        target: { media: 'basic' },
        space: 'basic',
        actor: { media: 'basic' },
        object: {
            media: 'basic',
        },
    }, useInfiniteQueryOptions, } = options || {};
    const { client } = useTribeClient();
    const notificationsKey = getNotificationsKey(variables);
    return useInfiniteQuery(notificationsKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.notifications.list({
        after,
        ...variables,
    }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useNotifications.js.map